import { Grid, Tab, Tabs, styled } from "@mui/material";
import React, { useEffect } from "react";

import { WALLET_TYPE } from "pages/BasicTrade/components/constants";
import { useSearchParams } from "react-router-dom";

function WalletTabs({ handleGetWalletInfo }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const walletTypeId = +searchParams.get("walletTypeId") || 1;

  const handleChangeTab = (_, tab) => {
    handleGetWalletInfo(tab);

    const allSearchParams = Object.fromEntries([...searchParams]);

    setSearchParams({
      ...allSearchParams,
      walletTypeId: tab,
    });
  };

  useEffect(() => {
    handleGetWalletInfo(walletTypeId);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid item xs={12}>
      <TabsStyle value={walletTypeId} onChange={handleChangeTab}>
        <Tab value={WALLET_TYPE.spot} label="Spot" />

        <Tab value={WALLET_TYPE.margin} label="Margin" />
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",
  },
}));

export default WalletTabs;
